import isBoolean from './isBoolean'
import inBrowser from './inBrowser'

const scrollIntoView = (el, config) => {
  if (!inBrowser || !el) return

  const { offset, alignToTop, container, ...options } = isBoolean(config)
    ? ({ alignToTop: config })
    : config

  if (offset && offset > 0) {
    if (container) {
      const top = el.offsetTop - offset
      container.scroll({ ...options, top })
    } else {
      const rec = el.getBoundingClientRect()
      const top = rec.top + window.scrollY - offset

      window.scrollTo({ ...options, top })
    }
  } else {
    el.scrollIntoView(alignToTop == null ? options : alignToTop)
  }
}

export default scrollIntoView
